import React from 'react';
import styled from 'astroturf/react';
import routes from 'js/core_pre_webpack/routes';
import { Icon } from 'js/design_system/Icon';
import { trackNavClicked } from 'js/research_radar/tracking';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { IconAnchor, IconContainer, IconLabel } from './buttonStyles';

const GreenDot = styled.div`
  position: absolute;
  top: 0;
  right: -3px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--success-dark, #05b01c);
`;

const RelativeIconContainer = styled(IconContainer)`
  position: relative;
`;

type RadarNavButtonProps = {
  hasUnreadResults: boolean;
  source: 'desktop' | 'mobile';
};

const RadarNavButton = ({
  hasUnreadResults,
  source,
}: RadarNavButtonProps): JSX.Element => (
  <ImpressionWatcher key="radar" source="research_radar.nav">
    <IconAnchor
      href={routes.research_radar_url({ from_navbar: true, trigger: 'nav' })}
      onClick={() => trackNavClicked(source)}
    >
      <RelativeIconContainer>
        <Icon name="sensors" size={28} />
        {hasUnreadResults && <GreenDot />}
      </RelativeIconContainer>
      <IconLabel>Radar</IconLabel>
    </IconAnchor>
  </ImpressionWatcher>
);

export default RadarNavButton;
